<template>
  <div class="form-row d-info d-frame">
    <h3>Instrukcja aktywacji:</h3>
    <ul>
      <li>Kup klucz</li>
      <li>Wejdź na stronę <a href="http://www.thesettlersonline.pl" target="_blank">www.thesettlersonline.pl</a></li>
      <li>Zarejestruj się, a następnie zaloguj na swoje konto użytkownika</li>
      <li>Przejdź na stronę <a href="http://www.thesettlersonline.pl/pl/kupon" target="_blank">www.thesettlersonline.pl/pl/kupon</a></li>
      <li>Przepisz kod i kliknij przycisk "Wykorzystaj kod promocyjny"</li>
    </ul>
    <p>Karty przedpłacone ozdabia charakterystyczna grafika z The Settlers Online, mają one wartość 40 lub 80 PLN. Wszystko, co musisz zrobić, to wpisać kod zawarty na każdej z kart w odpowiednie pole na stronie, a następnie kliknąć na "Wykorzystaj kod promocyjny". W przeciągu kilku sekund zasilimy twoje konto The Settlers Online odpowiednią sumą Klejnotów wraz z premią plus 75%.</p>
  </div>
</template>

<script>
export default {
  name: 'TopupCodesInfoSettlers'
}
</script>
